import { render, staticRenderFns } from "./part-flight-type.vue?vue&type=template&id=15658fce&lang=pug"
import script from "./part-flight-type.vue?vue&type=script&lang=js"
export * from "./part-flight-type.vue?vue&type=script&lang=js"
import style0 from "./part-flight-type.vue?vue&type=style&index=0&id=15658fce&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports